var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-divider',{style:({ color: '#7fddad', borderColor: '#07c160', padding: '0 16px' })},[_c('h3',[_vm._v("images 使用示例")])]),_c('img',{attrs:{"src":_vm.topImg,"alt":""}}),_c('img',{attrs:{"src":_vm.qywxImg,"alt":""}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.csImg,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }